import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

class TeamsSecondStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  render() {
    const { className } = this.props

    return (
      <div className={className}>
        <img
          src={`${STATIC_BASE_URL}/static/webapp/images/settings/teams-second-step.png`}
          style={{ width: '423px', height: '423px' }}
        />
        <div className="actions-container">
          <div className="mt">
            <div className="number-indication">1</div>
            <span className="text-indication">
              Click the
              <span style={{ fontWeight: 'bold' }}>
                {' '}
                Post to a channel when a webhook request is received{' '}
              </span>
              link
            </span>
          </div>
          <div className="mt">
            <div className="number-indication">2</div>
            <span className="text-indication">
              Optionally change the workflow's default name and click{' '}
              <span style={{ fontWeight: 'bold' }}>Next</span>
            </span>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="teams-backButton"
          />
          <Button
            text="Next Step"
            onClick={() => this.handleStepRedirect(1)}
            className="sml"
            id="teams-nextButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(TeamsSecondStep)`
  .buttons-container {
    margin-top: 80px;
  }
`
